/**
 * @generated SignedSource<<ed74709581186e3ccb50ba94a46a2119>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type AccountType = "COLLATERAL" | "CREDIT_CARD_COLLATERAL" | "DEFI_BORROW_COLLATERAL" | "DEFI_YIELD" | "FIAT" | "FIAT_SAVINGS" | "FUTURES_CFM" | "MULTISIG" | "MULTISIG_VAULT" | "PREDICTION_MARKETS_CFM" | "RAISE_INVESTMENTS" | "RETAIL_DEFI_LEND" | "STAKED_FUNDS" | "UNKNOWN" | "VAULT" | "WALLET" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type readFiatWalletsAccountFragment$data = {
  readonly type: AccountType;
  readonly uuid: string;
  readonly " $fragmentSpreads": FragmentRefs<"readFiatWalletAccountFragment">;
  readonly " $fragmentType": "readFiatWalletsAccountFragment";
};
export type readFiatWalletsAccountFragment$key = {
  readonly " $data"?: readFiatWalletsAccountFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"readFiatWalletsAccountFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "readFiatWalletsAccountFragment"
};

(node as any).hash = "eb37ccf1cb488c2aea12925f05dfea37";

export default node;
